import { useNavigate } from "react-router-dom";
import { useAppState } from "../app";
import { ApplicationPage } from "./application-page";
import { useGlobalNotifier, useMessage } from "@vrf/fr-vrf-core-react";
import { ApplicationMessageScreen } from "../messages/screen-message";

export const usePageNavigation = <LocationState = any>() => {
  const [appState, setAppState] = useAppState();
  const navigate = useNavigate();
  const { messageForScreen } = useMessage();
  const { showToast, resetUserError } = useGlobalNotifier();
  const moveToPage = (pageId: string, state?: LocationState) => {
    navigate(ApplicationPage.pathById(pageId) || pageId, { state: state });
  };

  const backToPrevPage = () => {
    isModalPage() ? closeModalPage() : navigate(-1);
  };

  const moveToModalPage = () => {
    setAppState((prevState) => ({
      ...prevState,
      currentModalPage: "modalPage",
    }));
  };

  const closeModalPage = () => {
    setAppState((prevState) => ({
      ...prevState,
      currentModalPage: undefined,
    }));
  };

  const isPageChanged = (): boolean => appState.pageChanged;

  const setPageChanged = (pageChanged: boolean) => {
    setAppState((prevState) => ({
      ...prevState,
      pageChanged: pageChanged,
    }));
  };

  const ifCameFromCertainPage = (pageId: string): boolean => false;

  const ifNotCameFromCertainPage = (pageId: string): boolean => true;

  const isModalPage = (): boolean => !!appState.currentModalPage;

  const initUserError = () => {
    (async () => {
      await resetUserError();
      if (appState.isShowSuccessToast) {
        showToast({
          design: "completion",
          message: messageForScreen(ApplicationMessageScreen.APP_SCN_00044),
        });
      }
    })();
    setAppState((prevState) => ({
      ...prevState,
      isShowSuccessToast: false,
    }));
  };

  return {
    moveToPage,
    backToPrevPage,
    moveToModalPage,
    closeModalPage,
    ifCameFromCertainPage,
    ifNotCameFromCertainPage,
    isPageChanged,
    setPageChanged,
    isModalPage,
    initUserError,
  } as const;
};
